import { ElMessage } from '@bilibili/magic-cube-plus';
import ajax from '@/common/utils/http/ajax';
import { post } from '@/common/utils/request';
import type { ApiResponse } from '@/types/types';

const api = {
    portal: import.meta.env.VITE_API_MALL_MERCHANT_PORTAL,
    items: import.meta.env.VITE_API_ITEMS
};

export const getContractInfo = (params: any) => {
    return post('/mall-merchant-items/merchant-contract/c/v2/default-contract', params);
};

export const signAgreement = (params: { contractId: string }) => {
    return post('/mall-merchant-items/merchant-contract/c/sign-contract', params);
};

/**
 * 获取商家状态
 *
 * @tags 商家维度-相关接口
 * @name GetMerchantStatusUsingPost
 * @summary 获取商家状态
 * @request POST:/mall-merchant-items/merchant/getMerchantBindBankInfo
 */
export const getMerchantStatus = (params: any) =>
    post<ApiResponse<any>>('/mall-merchant-items/merchant/getMerchantBindBankInfo', params);

// 账号信息查询
export const merchantInfo = () => {
    return ajax.get(`${api.portal}/user/info`).then((response) => {
        if (response.code === 0) {
            return response.data;
        }
        return Promise.reject(response.message || '未登录');
    });
};
// 获取客服设置
export const getCustomInfo = () => {
    return ajax.get(`${api.items}/merchant/customer-service/config/get`).then((response) => {
        if (response.code === 0) {
            return response.data;
        }
        return Promise.reject('请求错误');
    });
};
